import _regeneratorRuntime from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _createClass from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
export var HttpResponse = function HttpResponse(status, headers, data) {
  _classCallCheck(this, HttpResponse);

  this.Status = status;
  this.headers = headers;
  this.Data = data;
};
export var Http =
/*#__PURE__*/
function () {
  function Http() {
    _classCallCheck(this, Http);
  }

  _createClass(Http, null, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(serviceOptions, path) {
        var headers, options, response, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headers = {
                  'X-AppEnvId': serviceOptions.appEnvId
                };

                if (serviceOptions.apiKey) {
                  headers['Authorization'] = "ApiKey ".concat(serviceOptions.apiKey);
                }

                options = {
                  headers: headers
                };
                _context.next = 5;
                return fetch(this.buildUrl(serviceOptions, path), options);

              case 5:
                response = _context.sent;
                _context.prev = 6;
                _context.next = 9;
                return response.json();

              case 9:
                body = _context.sent;
                return _context.abrupt("return", new HttpResponse(response.status, response.headers, body));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                return _context.abrupt("return", new HttpResponse(response.status, response.headers));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13]]);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getWithUserToken",
    value: function () {
      var _getWithUserToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(serviceOptions, path, userToken) {
        var options, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = {
                  headers: {
                    Authorization: "ApiKey ".concat(serviceOptions.apiKey),
                    'X-AppEnvId': serviceOptions.appEnvId,
                    'X-User-Token': userToken
                  }
                };
                _context2.next = 3;
                return fetch(this.buildUrl(serviceOptions, path), options);

              case 3:
                response = _context2.sent;
                _context2.t0 = HttpResponse;
                _context2.t1 = response.status;
                _context2.t2 = response.headers;
                _context2.next = 9;
                return response.json();

              case 9:
                _context2.t3 = _context2.sent;
                return _context2.abrupt("return", new _context2.t0(_context2.t1, _context2.t2, _context2.t3));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getWithUserToken(_x3, _x4, _x5) {
        return _getWithUserToken.apply(this, arguments);
      }

      return getWithUserToken;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(serviceOptions, path, body) {
        var options, response, returnbody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = {
                  method: 'POST',
                  headers: {
                    Authorization: "ApiKey ".concat(serviceOptions.apiKey),
                    'X-AppEnvId': serviceOptions.appEnvId,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(body)
                };
                _context3.next = 3;
                return fetch(this.buildUrl(serviceOptions, path), options);

              case 3:
                response = _context3.sent;
                _context3.prev = 4;
                _context3.next = 7;
                return response.json();

              case 7:
                returnbody = _context3.sent;
                return _context3.abrupt("return", new HttpResponse(response.status, response.headers, returnbody));

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](4);
                return _context3.abrupt("return", new HttpResponse(response.status, response.headers));

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 11]]);
      }));

      function post(_x6, _x7, _x8) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "postWithUserToken",
    value: function () {
      var _postWithUserToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(serviceOptions, path, userToken, body) {
        var options, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = {
                  method: 'POST',
                  headers: {
                    Authorization: "ApiKey ".concat(serviceOptions.apiKey),
                    'X-AppEnvId': serviceOptions.appEnvId,
                    'X-User-Token': userToken,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(body)
                };
                _context4.next = 3;
                return fetch(this.buildUrl(serviceOptions, path), options);

              case 3:
                response = _context4.sent;
                _context4.prev = 4;
                _context4.next = 7;
                return response.json();

              case 7:
                body = _context4.sent;
                return _context4.abrupt("return", new HttpResponse(response.status, response.headers, body));

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](4);
                return _context4.abrupt("return", new HttpResponse(response.status, response.headers));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 11]]);
      }));

      function postWithUserToken(_x9, _x10, _x11, _x12) {
        return _postWithUserToken.apply(this, arguments);
      }

      return postWithUserToken;
    }()
  }, {
    key: "deleteWithUserToken",
    value: function () {
      var _deleteWithUserToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(serviceOptions, path, userToken) {
        var options, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = {
                  method: 'DELETE',
                  headers: {
                    Authorization: "ApiKey ".concat(serviceOptions.apiKey),
                    'X-AppEnvId': serviceOptions.appEnvId,
                    'X-User-Token': userToken
                  }
                };
                _context5.next = 3;
                return fetch(this.buildUrl(serviceOptions, path), options);

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", new HttpResponse(response.status, response.headers));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteWithUserToken(_x13, _x14, _x15) {
        return _deleteWithUserToken.apply(this, arguments);
      }

      return deleteWithUserToken;
    }()
  }, {
    key: "buildUrl",
    value: function buildUrl(options, path) {
      return "".concat(options.baseUrl).concat(path);
    }
  }]);

  return Http;
}();